import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { useForm, Head, router } from "@inertiajs/react";

import Button from "/components/Button";
import TextField from "/components/TextField";
import Modal from "/components/Modal";
import SortableColumnHead from "/components/Admin/SortableColumnHead";

export default function DictionaryIndex({
  title,
  items,
  base_path,
  sorting_params,
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState();
  const [managedItems, setManagedItems] = useState(items);

  const addItem = () => {
    setManagedItems([...managedItems, { key: uuidv4() }]);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteClick = (item) => {
    if (item.id) {
      setItemToDelete(item);
      setIsDeleteModalOpen(true);
    } else {
      setManagedItems(managedItems.filter(currentItem => item.key !== currentItem.key));
    }
  };

  const handleChange = (item, newItem) => {
    const isTheItem = (currentItem) => item.id ? currentItem.id === item.id : currentItem.key === item.key;
    const newItems = managedItems.map(currentItem => isTheItem(currentItem) ? newItem : currentItem);
    setManagedItems(newItems);
  };

  const deleteItem = async () => {
    await router.delete(
      `${base_path}/${itemToDelete.id}`, {
        preserveScroll: true,
        onSuccess: () => {
          setManagedItems(managedItems.filter(item => item.id !== itemToDelete.id));
        },
      }
    );
    setIsDeleteModalOpen(false);
  };

  const sortingStatus = (field) => {
    if (sorting_params[0] !== field)
      return null;

    return sorting_params[1];
  };

  const onSorting = (field) => (dir) => {
    router.get(
      base_path,
      { sort_by: `${field} ${dir}` }
    )
  };

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        className="modal--autowidth"
      >
        <div className="modal__text">
          Вы уверены, что хотите<br />удалить эту запись?
        </div>

        <div className="modal__actions">
          <Button onClick={deleteItem} className="btn btn--dark">Удалить</Button>
          <Button onClick={handleCloseDeleteModal}>Отменить</Button>
        </div>
      </Modal>

      <div className="table-header">
        <div className="table-header__left">
          <h2>{title}</h2>
        </div>

        <div className="table-header__right">
          <Button className="btn" onClick={addItem}>Добавить</Button>
        </div>
      </div>

      <table className="tbl">
        <thead>
          <tr>
            <SortableColumnHead status={sortingStatus('name_ru')} onClick={onSorting('name_ru')}>Название</SortableColumnHead>
            <SortableColumnHead status={sortingStatus('name_en')} onClick={onSorting('name_en')}>Name</SortableColumnHead>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {managedItems.map((item) => (
            <DictionaryItem key={item.id || item.key} item={item} base_path={base_path} onChange={handleChange} onDelete={handleDeleteClick} />
          ))}
        </tbody>
      </table>
    </>
  );
}

function DictionaryItem({
  item,
  base_path,
  onChange,
  onDelete,
}) {
  const [editMode, setEditMode] = useState(!item.id);
  const { data, setData, post, put, reset, errors } = useForm(item);

  const handleSubmit = () => {
    if (item.id) {
      put(
        `${base_path}/${item.id}`,
        {
          preserveScroll: true,
          preserveUrl: true,
          only: ["updated_item"],
          onSuccess: (response) => {
            onChange(item, response.props.updated_item);
            setEditMode(false);
          },
        }
      );
    } else {
      post(
        base_path,
        {
          preserveScroll: true,
          preserveUrl: true,
          only: ["created_item"],
          onSuccess: (response) => {
            onChange(item, response.props.created_item);
            setEditMode(false);
          },
        }
      );
    }
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleCancel = () => {
    if (item.id) {
      reset();
      setEditMode(false);
    } else {
      onDelete(item);
    }
  };

  return editMode ? (
    <tr>
      <td>
        <TextField
          value={data.name_ru}
          placeholder="Название"
          onChange={value => setData("name_ru", value)}
          errors={errors.name_ru}
        />
      </td>
      <td>
        <TextField
          value={data.name_en}
          placeholder="Name"
          onChange={value => setData("name_en", value)}
          errors={errors.name_en}
        />
      </td>
      <td className="tbl-extra">
        <div className="tbl-actions-wrapper tbl-actions-wrapper--floating">
          <div className="tbl-actions">
            <div className="flex-row gap-3">
              <Button className="lnk lnk--green" onClick={handleSubmit}>Сохранить</Button>
              <Button className="lnk" onClick={handleCancel}>Отменить</Button>
            </div>

            <div className="flex-row">
              <Button className="lnk lnk--red" onClick={() => onDelete(item)}>Удалить</Button>
            </div>
          </div>
        </div>
      </td>
    </tr>
  ) : (
    <tr>
      <td>{data.name_ru}</td>
      <td>{data.name_en}</td>
      <td className="tbl-extra">
        <div className="tbl-actions tbl-actions--hiding">
          <Button className="lnk lnk--blue" onClick={handleEdit}>Редактировать</Button>
          <Button className="lnk lnk--red" onClick={() => onDelete(item)}>Удалить</Button>
        </div>
      </td>
    </tr>
  );
}
